import { render, staticRenderFns } from "./RegistrationsSnapshot.vue?vue&type=template&id=2b3d70cc&scoped=true"
import script from "./RegistrationsSnapshot.vue?vue&type=script&lang=js"
export * from "./RegistrationsSnapshot.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsSnapshot.vue?vue&type=style&index=0&id=2b3d70cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d70cc",
  null
  
)

export default component.exports